import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { DownloadFile, SearchResult, GraphDataset, GraphDataEntry } from '../../model/analysis-details.model';
import { DBService } from '../../service/DB.service';
import { ActivatedRoute, Router } from '@angular/router';
import { interval } from 'rxjs/internal/observable/interval';
import { User } from '../../model/types';
import { SharedService } from '../../layouts/shared-service';
import { Subscription } from 'rxjs/Subscription';
import { AuthNewService } from '../../service/auth-new.service';
import { Observable, Subject } from 'rxjs';
import { switchMap, take, takeUntil, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { StorageService } from '../../service/storage.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import jsPDF from 'jspdf';
// const htmlToPdfmake = require("html-to-pdfmake");
import htmlToPdfmake from 'html-to-pdfmake';
pdfMake.vfs = pdfFonts.vfs;
import { DatePipe } from '@angular/common';
import Plotly from 'plotly.js-dist';
import { DropDownService } from '../../service/drop-down.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DownLoadService } from '../../service/download.service';

@Component({
    selector: 'app-qpcr-result-page',
    templateUrl: './qpcr-result-page.component.html',
    styleUrls: ['./qpcr-result-page.component.scss']
})
export class QpcrResultPageComponent implements OnInit, OnDestroy {
    maxDate?: Date;
    pageTitle = 'Analyze Report/Data';
    searchResult: SearchResult = <SearchResult>{};
    searchResultData = true;
    isFetching = true;
    signedInUser: any;
    currentUser?: User;
    illegalUser?: boolean;
    usr: any;
    analysisId = '';
    navigationSubscription?: Subscription;
    qpcrTables = [];
    step = 0;
    urlPath?: string;
    signedInUserAccess?: string | null;
    errorResult?: string;
    private singleSearchData?: Subscription;
    private currentLoginUser?: Subscription;
    private PostEventData?: Subscription;
    private getEventData?: Subscription;
    EventDataUrl: string = environment.serverUrl + '/event-data';
    AnalysisDataURL: string = environment.serverUrl + '/analysis-data';
    regressionUrl: string = environment.serverUrl + '/regression';
    commentUrl: string = environment.serverUrl + '/comment-data';

    DownloadFileobject: DownloadFile = <DownloadFile>{};
    AnalysisViewType?: string | null;
    QpcrPdfData?: string[];
    AuditPdfData?: string[];
    @ViewChild('htmlData', { static: false }) htmlData!: ElementRef;
    @ViewChild('auditData', { static: false }) auditData!: ElementRef;
    logo?: string;
    graphdata?: GraphDataset[] = [];
    graphHistoryData?: string[];
    checkboxSelected = false;
    commentText: { target_name: string, run_id: string, selected_samples: string[], sample_flag_selected: boolean[], comments: string[], CQ: (string | null)[], WellPosition: (string | null)[] }[] = [];
    selectedSampleNames: { run_id: string, selected_samples: string[] }[] = [];
    selectedComments: string[] = [];
    targetInfoList: { name: string, type: string }[] = [];
    analysisStatusText = 'Gathering Information ';
    graphHistoryDataKeys?: string[];
    initialSampleNames = [];
    calc_CV = [];
    RE = [];
    submitResultLoader = false;
    submitEnabled = true;
    disableSubmit = true;
    executionId?: string;
    selectedRows: number[] = [];
    regressionApiError = '';
    recalculationStates: boolean[] = [];
    panelStates: { run_id: string, target_name: string[] }[] = [];
    // panelStates: { [key: string]: boolean } = {};
    groupedData: any[] = [];
    fetchingEventData = true;
    pollingSubscription?: Subscription;
    userGroup: any;
    userOrganization: any;
    private stopPolling = new Subject<void>();
    graphLoadingStates: boolean[] = [];
    @ViewChild('RApaginator', { static: false }) paginator!: MatPaginator;
    paginatedData = new MatTableDataSource<any>([]);
    currentPageData: GraphDataEntry[] = [];
    filteredData: string | null = '';
    pageIndex = 0;
    lastPageIndex = 0;
    showSubmitButton?: boolean = false;
    hasVisitedLastPage = false;
    finalPdfFilename?: string;
    finalexcelFilename?: string;
    hasRegressionData?: boolean = false;
    selectedTargetName?: string | null;
    fetchRegressionData = false;
    signedpath?: string;
    savedTargetData: { [key: string]: boolean } = {};
    calledPanels: Set<string> = new Set();
    errormessage = false;
    callEvent = true;
    usersignedpath?: string;
    projectVersion = environment.version;
    targetNames?: string[] = [];
    selectedCompileRuns: any[] = [];
    dataSource?: MatTableDataSource<any>
    displayedColumns: string[] = ['select', 'run_id', 'target_type', 'run_status', 'username', 'analysis_date', 'project_code'
    ];
    MatTableDataSource: any;
    submitMessage?: string;
    submitStatus: boolean = true;


    constructor(
        private http: HttpClient,
        private dbService: DBService,
        private activatedroute: ActivatedRoute,
        private dropDownService: DropDownService,
        private _sharedService: SharedService,
        private downloadService: DownLoadService,
        private storageService: StorageService,
        public datepipe: DatePipe,
        private cdr: ChangeDetectorRef,
    ) {
        this._sharedService.emitChange(this.pageTitle);
    }

    getDisplayString(key: string) {
        return this.dropDownService.nameDescMap.get(key);
    }


    ngOnInit() {
        this.fetchAnalysisData();
    }

    async fetchAnalysisData() {
        this.pollForResult();
        this.AnalysisViewType = this.activatedroute.snapshot.paramMap.get('type');
        this.usr = this.activatedroute.snapshot.paramMap.get('user');
        this.analysisId = this.activatedroute.snapshot.paramMap.get('id') ?? '';
        try {
            const data = await this.dbService.singleSearch.pipe(take(1)).toPromise();
            if (Object.keys(data).length === 0) {
                this.searchResultData = false;
            }
            else {
                this.isFetching = false;

            }
            data && this.populateResultData(data);
            this.loadImageAsBase64('/assets/img/App-Biodata.png');
        } catch (error) {
            console.error('Error occurred:', error);
        }
        this.populateTargetInfo();
    }

    onTargetChange(targetName: string) {
        this.selectedTargetName = targetName;
       
        this.checkPanelStatus();
        if (this.searchResult.analysisType === 'qPCR-Compilation' && this.searchResult.CompileRuns) {
            const targetData = this.searchResult.CompileRuns.find(run => run.target_name === targetName);
            this.selectedCompileRuns = targetData ? targetData.compile_runs : [];
            this.dataSource = new MatTableDataSource(this.selectedCompileRuns);
            setTimeout(() => this.dataSource!.paginator = this.paginator ?? null);
        }
        else {
            const targetData = this.graphdata?.find((res) => res.target_name === targetName);
            this.paginatedData = new MatTableDataSource(targetData?.graph_data || []);
            setTimeout(() => {
                this.paginator?.firstPage();
                this.paginatedData.paginator = this.paginator;
                if (this.paginator) {
                    this.calculateLastPageIndex(); // Calculate last page index here
                    this.paginator?.page.subscribe(() => {
                        this.pageIndex = this.paginator?.pageIndex;
                        this.checkIfLastPage();
                        this.renderGraphsForCurrentPage(); // Re-render graphs for the visible page
                    });
                }
                this.renderGraphsForCurrentPage();

            }, 0);
        }


    }

    calculateLastPageIndex() {
        setTimeout(() => {
            if (this.paginator && this.paginator.length > 0) {
                this.lastPageIndex = Math.ceil(this.paginator?.length / this.paginator?.pageSize) - 1;
                if (this.paginator?.length <= this.paginator?.pageSize) {
                    this.hasVisitedLastPage = true;
                    // this.showSubmitButton = true;
                }
            } else {
                // setTimeout(() => this.calculateLastPageIndex(), 100); // Retry after 100ms
            }
        }, 0);
    }

    checkIfLastPage() {
        if (this.paginator) {
            // Check if user is on last page
            if (this.paginator?.pageIndex === this.lastPageIndex) {
                this.hasVisitedLastPage = true; // Mark as visited
            }
        }
    }

    loadImageAsBase64(url: string) {
        this.http.get(url, { responseType: 'blob' }).subscribe((blob: Blob) => {
            const reader = new FileReader();
            reader.onload = () => {
                this.logo = reader.result as string;
            };
            reader.readAsDataURL(blob);
        });
    }

    async populateResultData(data: SearchResult): Promise<any> {
        this.searchResult = data;
        this.errorResult = this.searchResult.error_message;
        this.QpcrPdfData = this.searchResult.pdf_data;
        this.hasRegressionData = this.hasKey();
        const dateObj = new Date(this.searchResult.analysis_date);
        const timeParts = dateObj.toTimeString().split(' ')[0].split(':');
        const formattedTime = `${timeParts[0]}H${timeParts[1]}M${timeParts[2]}S`;
        this.finalPdfFilename = this.searchResult.projectCode + '_' + formattedTime;
        this.graphdata = this.searchResult.GraphData;
        if (this.searchResult.commentText) {
            this.commentText = this.searchResult?.commentText;
        }
        this.recalculationStates = new Array(this.graphdata?.length).fill(false);
        this.panelStates = new Array(this.graphdata?.length).fill(false);
        this.graphHistoryData = this.searchResult.initial_graph_data;
        this.extractQTtargetNames();
        this.checkIfAllTargetsSaved();
        this.checkPanelStatus();
        if (this.callEvent) {
            const eventName = 'View Data Handling Summary Page';
            this.callInitialEventData(eventName);
        }
        else {
            this.GetEventData();
        }
    }

    extractQTtargetNames() {
        if (this.searchResult.analysisType === 'qPCR') {
            this.targetNames = this.searchResult?.TargetNames?.filter((res: any) => res.TargetType === 'QT').map((name: any) => name.targetName);
        }
        else
            this.targetNames = this.searchResult?.TargetNames?.map((name: any) => name.targetName);

    }

    hasKey(): boolean | undefined {
        return this.QpcrPdfData?.some((file: any) =>
            file.table.data.some((row: any) => row.hasOwnProperty('slope') || row.hasOwnProperty('intercept') || row.hasOwnProperty('r2'))
        );
    }

    callInitialEventData(eventName: string) {
        this.fetchingEventData = true;
        const downloadFileObject = {
            userId: this.storageService.get('userId'),
            eventName: eventName,
            analysisId: this.analysisId,
            userName: this.storageService.get('userName'),
            userRole: this.storageService.get('access')
        };
        let params = new HttpParams();
        params = params.append('analysisId', this.analysisId ?? '');
        return this.http.post(this.EventDataUrl, downloadFileObject)
            .subscribe(
                (response) => {
                    this.getEventData = this.http.get(this.EventDataUrl, { params: params }).subscribe(
                        (res: any) => {
                            this.AuditPdfData = res;
                            this.fetchingEventData = false;
                        }
                    );
                }
                ,
                (error) => {
                    console.error('API call error:', error);
                }
            );

    }

    callEventData(eventName: string, date = null): Observable<any> {
        const downloadFileObject = {
            userId: this.storageService.get('userId'),
            eventName: eventName,
            analysisId: this.analysisId,
            userName: this.storageService.get('userName'),
            userRole: this.storageService.get('access'),
            analysisDate: date
        };
        let params = new HttpParams();
        params = params.append('analysisId', this.analysisId ?? '');
        return this.http.post(this.EventDataUrl, downloadFileObject);
    }

    GetEventData() {
        this.fetchingEventData = true;
        let params = new HttpParams();
        params = params.append('analysisId', this.analysisId ?? '');
        this.getEventData = this.http.get(this.EventDataUrl, { params: params }).subscribe(
            (res: any) => {
                this.AuditPdfData = res;
                this.fetchingEventData = false;
            },
            (error) => {
                console.error('API call error:', error);
            }
        );

    }

    applyFilter(filterValue: string) {
        const filterText = filterValue.trim().toLowerCase();
        this.paginatedData.filter = filterText;
        const matchedItem = this.paginatedData.data.find(item =>
            JSON.stringify(item).toLowerCase().includes(filterText));

        const matchedIndex = this.paginatedData.data.findIndex(item =>
            JSON.stringify(item).toLowerCase().includes(filterText));

        if (matchedItem !== undefined && matchedIndex !== -1) {
            this.filteredData = matchedItem;
            // Pass single object and single index to the plot function
            this.CreateUpdatePlot(matchedItem, matchedIndex);
        } else {
            this.filteredData = null;
        }
    }


    renderGraphsForCurrentPage(): void {
        this.checkIfAllTargetsSaved();
        this.checkPanelStatus();
        if (!this.paginatedData || !this.paginator) { return; }
        this.currentPageData = this.paginatedData.data.slice(
            this.paginator.pageIndex * this.paginator.pageSize,
            (this.paginator.pageIndex + 1) * this.paginator.pageSize
        );

        this.currentPageData.forEach(dataObj => {
            const storedComment = this.commentText.find(c => c.run_id === dataObj.run_id && c.target_name === dataObj.target_name);
            if (storedComment) {
                dataObj.comment = dataObj.comment.map((tableDataObj: any, index) => {
                    return {
                        ...tableDataObj,
                        comment: storedComment.comments[index] || tableDataObj.comment
                    };
                });
            }
        });

        setTimeout(() => {
            this.currentPageData.forEach((dataObj, index) => {
                this.CreateUpdatePlot(dataObj, index);
            });
        }, 200);
        this.initiateGraphData();
        this.cdr.detectChanges();

    }

    initiateGraphData() {
        if (this.currentPageData && this.currentPageData.length > 0) {
            this.currentPageData.forEach(dataObj => {
                this.initializeComments(dataObj);
            });
            if (!this.commentText) {
                this.commentText = []; // Ensure commentText is initialized
            }
            for (const dataObj of this.currentPageData) {
                new Promise(resolve => {
                    setTimeout(() => {
                        const existingComment = this.commentText.find(c => c.run_id === dataObj.run_id && c.target_name === dataObj.target_name);
                        if (!existingComment) {
                            const newCommentEntry = {
                                target_name: dataObj.target_name,
                                run_id: dataObj.run_id,
                                selected_samples: [] as string[],
                                sample_flag_selected: [] as boolean[],
                                comments: [] as string[],
                                CQ: [] as string[],
                                WellPosition: [] as string[]
                            };

                            dataObj.comment.forEach((tableDataObj: any) => {
                                newCommentEntry.selected_samples.push(tableDataObj.sample_id);
                                newCommentEntry.sample_flag_selected.push(tableDataObj.flag);
                                newCommentEntry.comments.push(tableDataObj.comment);
                                newCommentEntry.CQ.push(tableDataObj?.CQ);
                                newCommentEntry.WellPosition.push(tableDataObj.WellPosition);
                            });

                            this.commentText.push(newCommentEntry);
                        }
                        resolve(null); // Resolve the promise after processing this item
                    }, 1000);
                });
            }
        }
    }

    initializeComments(dataObj: any) {
        // Populate comments from `dataObj.comment` array if available
        if (Array.isArray(dataObj?.comment) && dataObj?.comment.length > 0) {
            dataObj.comment.forEach((backendComment: any) => {
                const sampleIndex = dataObj.table_data.data.findIndex(
                    (sample: any) => sample.sample === backendComment.sample_id
                );
                if (sampleIndex !== -1) {
                    dataObj.table_data.data[sampleIndex].comment = backendComment.comment;
                }
            });
        }

    }

    objectKeys(obj: any): string[] {
        return Object.keys(obj);
    }

    exportPDF() {
        if (this.searchResult.pdf_file_path) {
            const dateObj = new Date();
            const timeParts = dateObj.toTimeString().split(' ')[0].split(':');
            const formattedTime = `${timeParts[0]}H${timeParts[1]}M${timeParts[2]}S`;
            this.finalexcelFilename = this.searchResult.projectCode + '_' + formattedTime;
            this.usersignedpath = this.getSingedURL(this.searchResult.pdf_file_path, this.finalexcelFilename);
            return this.usersignedpath;

        }
        else {
            const maxDate = new Date();
            const maxUTCDate = this.datepipe.transform((maxDate), 'yyyy-MM-dd HH:mm:ss', 'UTC');
            const doc = new jsPDF();
            const pdfTable = this.htmlData?.nativeElement;
            const html = htmlToPdfmake(pdfTable.innerHTML);

            const documentDefinition = {
                content: [

                    {
                        image: this.logo,
                        width: 150,
                        style: 'logo',

                    }, {
                        text: maxUTCDate,
                        width: 35,
                        style: 'date',
                        bold: true,
                        fontSize: 10,

                    },
                    {
                        text: [{ text: 'Project Code: ', bold: true }, this.searchResult.projectCode],
                        width: 20,
                        alignment: 'left',
                        margin: [0, 20, 10, 0],
                        fontSize: 10,

                    },
                    {
                        text: [{ text: 'RedThread User Name: ', bold: true }, this.searchResult.userName],
                        width: 20,
                        alignment: 'left',
                        margin: [0, 5, 5, 0],
                        fontSize: 10,
                    },
                    {
                        text: [{ text: 'RedThread Analysis Date(UTC): ', bold: true }, this.searchResult.analysis_date],
                        width: 20,
                        alignment: 'left',
                        margin: [0, 5, 5, 0],
                        fontSize: 10,
                    },
                    {
                        text: ('RedThread User Uploaded File(s) Report'),
                        width: 100,
                        bold: true,
                        alignment: 'center',
                        margin: [10, 20, 10, 10],
                        decoration: 'underline',
                        fontSize: 15,
                    },
                    html
                ],
                styles: {
                    logo: {
                        alignment: 'left',
                    },
                    date: {
                        alignment: 'right'
                    }
                }

            };
            pdfMake.createPdf(documentDefinition).download(`RedThread User Uploaded File(s)_${this.finalPdfFilename}_${this.projectVersion}.pdf`);
        }
    }

    exportAuditPDF() {
        const maxDate = new Date();
        const maxAuditUTCDate = this.datepipe.transform((maxDate), 'yyyy-MM-dd HH:mm:ss', 'UTC');
        const doc = new jsPDF();
        const pdfTable = this.auditData?.nativeElement;
        const html = htmlToPdfmake(pdfTable.innerHTML);
        const documentDefinition = {
            content: [
                {
                    image: this.logo,
                    width: 150,
                    style: 'logo',
                    margin: [0, 10, 10, 10],
                    fontSize: 10,
                },
                {
                    text: maxAuditUTCDate,
                    width: 35,
                    style: 'date',
                    fontSize: 10,
                },
                {
                    text: [{ text: 'Project Code: ', bold: true }, this.searchResult.projectCode],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 20, 10, 0],
                    fontSize: 10,

                },
                {
                    text: [{ text: 'RedThread User Name: ', bold: true }, this.searchResult.userName],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: [{ text: 'RedThread Analysis Date(UTC): ', bold: true }, this.searchResult.analysis_date],
                    width: 20,
                    alignment: 'left',
                    margin: [0, 5, 5, 0],
                    fontSize: 10,
                },
                {
                    text: ('AUDIT REPORT'),
                    width: 100,
                    bold: true,
                    alignment: 'center',
                    margin: [10, 20, 10, 10],
                    decoration: 'underline',
                    fontSize: 15,
                },
                html
            ],
            styles: {
                logo: {
                    alignment: 'left',
                },
                date: {
                    alignment: 'right',
                }
            }

        };
        pdfMake.createPdf(documentDefinition).download(`RedThread Audit_${this.finalPdfFilename}_${this.projectVersion}.pdf`);

    }

    getSingedURL(path: string, fileExcelName: string) {
        if (path === undefined) {
            return ' ';
        }
        if (path.indexOf('https') !== -1) {
            return path;
        } else if (/\S/.test(path)) {
            return this.downloadService.getUrl(path, false, this.searchResult.analysisType, fileExcelName);
        } else {
            return ' ';
        }

    }

    getOutputFilePath(targetName: string, path: string) {
        const dateObj = new Date(this.searchResult.analysis_date);
        const timeParts = dateObj.toTimeString().split(' ')[0].split(':');
        const formattedTime = `${timeParts[0]}H${timeParts[1]}M${timeParts[2]}S`;
        this.finalexcelFilename = this.searchResult.projectCode + '_' + targetName + '_' + formattedTime;
        const eventName = `${targetName}: Result File Downloaded`;
        this.callInitialEventData(eventName);
        this.signedpath = this.getSingedURL(path, this.finalexcelFilename);
        return this.signedpath;

    }


    async pollForResult() {
        this.userGroup = this.storageService.get('group');
        this.userOrganization = this.storageService.get('organization');
        this.signedInUserAccess = this.storageService.get('access');
        if (this.signedInUserAccess == 'SU' || this.signedInUserAccess == 'GA' || this.signedInUserAccess == 'QA' || this.signedInUserAccess == 'PI') {
            const iteration1 = localStorage.getItem('iteration1Called');
            if (this.AnalysisViewType == null || iteration1 == 'true') {
                const status = await this.fetchAnalysisStatus();
            }
            this.dbService.getAnalysisDetails(this.usr, this.analysisId);
            this.illegalUser = false;
        }
    }

    async fetchAnalysisStatus(): Promise<string> {
        const iteration1 = localStorage.getItem('iteration1Called');
        return new Promise((resolve, reject) => {
            this.pollingSubscription = interval(5000)
                .pipe(
                    switchMap(() =>
                        this.dbService.getAnalysisStatus(
                            this.usr,
                            this.analysisId,
                            this.userOrganization,
                            this.userGroup
                        )
                    ),
                    takeUntil(this.stopPolling),
                    catchError((error) => {
                        console.error('Polling error:', error);
                        reject(error);
                        return [];
                    })
                )
                .subscribe(
                    (data) => {
                        const dataStatus = data.data['analysis_status'];
                        if (iteration1 == 'true') {
                            if (dataStatus === 'Complete' || dataStatus === 'Error') {
                                this.stopPolling.next(); // Stop polling when the desired status is reached
                                resolve(dataStatus);
                                localStorage.setItem('iteration1Called', 'false');
                            }
                        }
                        else {
                            if (dataStatus === 'Complete' || dataStatus === 'Pending' || dataStatus === 'Error') {
                                this.stopPolling.next(); // Stop polling when the desired status is reached
                                resolve(dataStatus);
                            }
                        }
                    },
                    (error) => {
                        console.error('Error during polling:', error);
                        reject(error);
                    }
                );
        });
    }

    toggleSelection(dataObj: any, sample: any, idx: number) {
        dataObj.save = false;
        idx = this.getwholeindex(idx);
        sample.flag = !sample.flag;
        const runId = dataObj.run_id;
        const targetName = dataObj.target_name;
        const sampleName = sample.sample;
        const comment = sample.comment;
        const filterText = this.commentText.filter((res) => res.target_name === dataObj.target_name && res.run_id === dataObj.run_id);
        const runEntry = filterText[0];
        if (sample.flag) {
            if (!runEntry.selected_samples.includes(sampleName)) {
                runEntry.selected_samples.push(sampleName);
                runEntry.sample_flag_selected.push(sample.flag); // Track flag status
                runEntry.comments.push(comment);// Store the comment for the sample
                runEntry.CQ.push(null);
                runEntry.WellPosition.push(null);
            }
            else {
                const sampleIndex = runEntry.selected_samples.indexOf(sampleName);
                runEntry.sample_flag_selected[sampleIndex] = !runEntry.sample_flag_selected[sampleIndex];
                runEntry.CQ[sampleIndex] = null;
                runEntry.WellPosition[sampleIndex] = null;
                sample.individual_sample_flag = sample.individual_sample_flag.map(() => false);
            }
        } else {
            // If the sample is unflagged (checkbox unchecked), remove it from the selected samples
            const sampleIndex = runEntry.selected_samples.indexOf(sampleName);

            if (sampleIndex !== -1) {
                // Remove sample name, comment, and flag from the respective arrays
                runEntry.selected_samples.splice(sampleIndex, 1);
                runEntry.sample_flag_selected.splice(sampleIndex, 1);
                runEntry.comments.splice(sampleIndex, 1);
                runEntry.CQ.splice(sampleIndex, 1);
                runEntry.WellPosition.splice(sampleIndex, 1);
                // If there are no more selected samples for this run_id, remove the entry from commentText
                // if (runEntry.selected_samples.length === 0) {
                //     this.commentText = this.commentText.filter(entry => entry.run_id !== runId);
                // }
            }
        }

        // After toggling, you may want to update the plot (if relevant)
        this.CreateUpdatePlot(dataObj, idx);
    }


    hasSelectedCheckboxes(dataObj: any): boolean {
        // Check if any sample has flag === true
        const hasFlagTrue = dataObj?.table_data?.data?.some((sample: any) => sample.flag === true);

        // Check if any individual_sample_flag array has true value
        const hasIndividualFlagTrue = dataObj?.table_data?.data?.some((sample: any) =>
            sample.individual_sample_flag?.some((individualFlag: boolean) => individualFlag === true)
        );
        return hasFlagTrue || hasIndividualFlagTrue;
    }

    shouldDisplayCommentBox(sample: any): boolean {
        return sample.flag || (sample.individual_sample_flag?.some((flag: boolean) => flag === true));
    }

    populateTargetInfo() {
        if (this.searchResult?.output_result_path) {
            this.targetInfoList = this.searchResult?.output_result_path.map(path => this.getTargetInfo(path));
        }
    }

    getTargetInfo(path: string): { name: string, type: string } {
        // Extract the part after 'Report/' and before '-output.xlsx'
        const regex = /output_(.+)_([^.]+)\.xlsx$/;
        const match = path.match(regex);
        if (match && match.length >= 3) {
            let type = match[2];

            // Replace short codes with full words
            if (type.toUpperCase() === 'QT') {
                type = 'Quantitative';
            } else if (type.toUpperCase() === 'QL') {
                type = 'Qualitative';
            }

            return {
                name: match[1], // Target name
                type: type, // Target type
            };
        }
        return { name: 'Unknown', type: 'Unknown' }; // Fallback if not matched
    }



    async CreateUpdatePlot(dataObj: GraphDataEntry, index: number): Promise<void> {
        this.updateSubmitEnabled();

        try {
            const data = dataObj.table_data.data;
            const selectedData = data.filter((item) => item.flag); // Selected samples
            const deselectedData = data.filter((item) => !item.flag); // Deselected samples
            // Extract the relevant values for plotting
            const selectedXValues = selectedData.map((item) => item.quantity_log10);
            const selectedYValues = selectedData.map((item) => item.cq_mean);
            const selectedSampleNames = selectedData.map((item) => item.sample);

            const deselectedXValues = deselectedData.map((item) => item.quantity_log10).map((value) => {
                const num = parseFloat(value); // Convert each string to a number
                return isNaN(num) ? NaN : num; // Ensure 'NaN' strings are converted to actual NaN
            });;
            const deselectedYValues = deselectedData.map((item) => item.cq_mean).map((value) => {
                const num = parseFloat(value); // Convert each string to a number
                return isNaN(num) ? NaN : num; // Ensure 'NaN' strings are converted to actual NaN
            });
            const deselectedSampleNames = deselectedData.map((item) => item.sample);

            const regression = this.calculateLinearRegression(deselectedXValues, deselectedYValues);
            const allXValues = data.map((item: any) => item.quantity_log10);
            const allYValues = data.map((item: any) => item.cq_mean);

            const xAxisRange = [Math.min(...allXValues), Math.max(...allXValues)];
            const yAxisRange = [Math.min(...allYValues), Math.max(...allYValues)];

            // Add margin of 5 to axis range
            const xMargin = (xAxisRange[1] - xAxisRange[0]) * 0.05;
            const yMargin = (yAxisRange[1] - yAxisRange[0]) * 0.05;

            const Data = [
                {
                    x: deselectedXValues,
                    y: deselectedYValues,
                    mode: 'markers',
                    type: 'scatter',
                    name: 'Data',
                    text: deselectedSampleNames,
                    textposition: 'top center',
                    marker: {
                        color: '#000000',
                        size: 10,
                        symbol: 'circle',
                    }
                },
                {
                    x: selectedXValues,
                    y: selectedYValues,
                    mode: 'markers',
                    type: 'scatter',
                    name: 'Deselected Values',
                    text: selectedSampleNames,
                    textposition: 'top center',
                    marker: {
                        color: '#0000FF',
                        size: 10,
                        symbol: 'diamond',
                    }
                },
                {
                    x: regression.x,
                    y: regression.y,
                    mode: 'lines',
                    type: 'scatter',
                    name: 'Linear Regression',
                    marker: {
                        color: '#20B2AA'
                    }

                },

            ];

            const layout = {
                title: 'Scatter Plot with Linear Regression',
                xaxis: {
                    title: 'Quantity Log10 (copies/rxn)',
                    range: [xAxisRange[0] - xMargin, xAxisRange[1] + xMargin]
                },
                yaxis: {
                    title: 'Mean Ct',
                    range: [yAxisRange[0] - yMargin, yAxisRange[1] + yMargin]
                }
            };
            // const plotId = 'plotlyDiv_' + dataObj.run_id;
            const plotId = `plotlyDiv_${dataObj.target_name}${dataObj.run_id}`;

            const element = document.getElementById(plotId);
            if (element) {
                await Plotly.newPlot(plotId, Data, layout);
            } else {
                console.error(`Element with ID ${plotId} not found.`);
            }
        }
        // Ensure DOM updates
        catch (error) {
            console.error('Error creating plot:', error);
        }
        finally {
            this.graphLoadingStates[index] = false;
            this.cdr.detectChanges();
        }

    }

    calculateLinearRegression(xValues: number[], yValues: number[]) {
        const filteredData = xValues
            .map((x, index) => ({ x, y: yValues[index] }))
            .filter(item => item.y !== null && !isNaN(item.y));
        const x = filteredData.map(item => item.x);
        const y = filteredData.map(item => item.y);
        const n = x.length;
        const sumX = x.reduce((acc, val) => acc + val, 0);
        const sumY = y.reduce((acc, val) => acc + val, 0);
        const sumXY = x.reduce((acc, val, i) => acc + val * y[i], 0);
        const sumXSquare = x.reduce((acc, val) => acc + val * val, 0);

        const slope = (n * sumXY - sumX * sumY) / (n * sumXSquare - sumX * sumX);
        const intercept = (sumY - slope * sumX) / n;
        const regressionLineX = [Math.min(...xValues), Math.max(...xValues)];
        const regressionLineY = [slope * regressionLineX[0] + intercept, slope * regressionLineX[1] + intercept];
        return { x: regressionLineX, y: regressionLineY };
    }

    trackByIndex(index: number, item: any): number {
        return index; // Ensure each row is uniquely identified by its index
    }

    isCheckboxDisabled(flags: boolean[], currentIndex: number): boolean {
        // Check if any checkbox in the row is selected, and disable others
        return flags.some((flag, index) => flag && index !== currentIndex);
    }

    toggleCqSelection(dataObj: any, sample: any, index: number, idx: number) {
        idx = this.getwholeindex(idx);
        dataObj.save = false;
        idx = this.getwholeindex(idx);
        sample.individual_sample_flag[index] = !sample.individual_sample_flag[index];
        const run_id = dataObj.run_id;
        const targetName = dataObj.target_name;
        const sample_name = sample.sample;
        const comment = sample.comment;
        const filterText = this.commentText.filter((res) => res.target_name === dataObj.target_name && res.run_id === dataObj.run_id);
        const commentEntry = filterText[0];
        const sampleIndex = commentEntry?.selected_samples?.indexOf(sample_name);
        if (sampleIndex === -1) {
            // Add new sample name and corresponding comment
            commentEntry.selected_samples.push(sample_name);
            commentEntry.sample_flag_selected.push(sample.flag);
            commentEntry.comments.push(comment);
        } else {
            // Update the comment for the existing sample name
            commentEntry.comments[sampleIndex] = comment;
            commentEntry.sample_flag_selected[sampleIndex] = sample.flag;
        }

        // Get the corresponding cq value based on the index
        const cqValue = sample.cq[index];
        const WellValue = sample.well_position[index];

        // Update the cq array for the corresponding run_id
        if (sample.individual_sample_flag[index]) {
            // If checkbox is checked, add the cq value to the cq array
            if (!commentEntry.CQ?.includes(cqValue)) {
                commentEntry.CQ.push(cqValue);
            }
            if (!commentEntry.WellPosition?.includes(WellValue)) {
                commentEntry.WellPosition.push(WellValue);
            }

        } else {
            // If checkbox is unchecked, remove the cq value from the cq array
            const indexToRemove = commentEntry?.CQ?.indexOf(cqValue);
            if (indexToRemove > -1) {
                commentEntry.CQ.splice(indexToRemove, 1);
                commentEntry.WellPosition.splice(indexToRemove, 1);

            }
            const sampleNameIndex = commentEntry.selected_samples.indexOf(sample_name);
            if (sampleNameIndex > -1) {
                commentEntry.selected_samples.splice(sampleNameIndex, 1);
                commentEntry.comments.splice(sampleNameIndex, 1);
                commentEntry.sample_flag_selected.splice(sampleNameIndex, 1);
            }
        }
        this.updateSubmitEnabled();
    }

    addComment(dataObj: GraphDataEntry, index: number, idx: number) {
        dataObj.save = false;
        idx = 10 * this.pageIndex + idx;
        const sample = dataObj.table_data?.data[index];
        const comment = sample?.comment?.trim() || ''; // Get the trimmed comment
        const sampleName = sample.sample; // Get the sample name
        const sampleFlag = sample.flag; // Get the flag value
        const runIndex = this.commentText.findIndex(entry =>
            entry.run_id === dataObj.run_id && entry.target_name === dataObj.target_name
        );

        if (runIndex !== -1) {
            // If entry exists, find the index of the sample in the selected samples array
            const sampleIndex = this.commentText[runIndex].selected_samples.indexOf(sampleName);

            if (sampleIndex !== -1) {
                // Update the existing comment, flag, CQ, and RE for the sample
                this.commentText[runIndex].comments[sampleIndex] = comment;
                this.commentText[runIndex].sample_flag_selected[sampleIndex] = sampleFlag;
            } else {
                // Add new sample, comment, and flag if not found
                this.commentText[runIndex].selected_samples.push(sampleName);
                this.commentText[runIndex].comments.push(comment);
                this.commentText[runIndex].sample_flag_selected.push(sampleFlag);

                // Add corresponding CQ and RE (use appropriate values based on your data)
                const cqValue = sample.cq[index];
                this.commentText[runIndex].CQ.push(cqValue);

            }
        } else {
            // Create a new entry for this run_id if it doesn't exist
            const cqValue = sample.cq[index];
            const WellValue = sample.well_position[index];

            this.commentText.push({
                target_name: dataObj.target_name,
                run_id: dataObj.run_id,
                selected_samples: [sampleName],
                comments: [comment],
                sample_flag_selected: [sampleFlag], // Store flag status
                CQ: [cqValue], // Add corresponding CQ
                WellPosition: [WellValue]
            });
        }


        this.updateSubmitEnabled(); // Update the submit button status based on changes
    }


    get isCommentsDisabled(): boolean {
        return this.searchResult.iteration === 1;
    }

    trackBySampleId(index: number, sample: any): string | null {
        return sample?.id || null; // Adjust based on unique identifier
    }

    isSubmitEnabled(): boolean {
        for (const commentObj of this.commentText) {
            const comments = commentObj.comments.filter((res) => res !== '' && res !== null);
            if (commentObj.selected_samples.length !== comments.length) {
                return false;
            }
        }
        return true;
    }


    updateSubmitEnabled() {
        this.submitEnabled = this.isSubmitEnabled();
    }


    isRecalculateEnabled(dataObj: GraphDataEntry) {
        let flagCondition = true;
        let individualFlagCondition = true;
        const refreshState = dataObj.table_data.data.some((sample) => {

            // Check if flag is true and a comment is entered
            flagCondition = sample.flag && sample.comment.trim().length == 0;
            // Check if any individual_sample_flag is true and a comment is entered
            individualFlagCondition = sample.individual_sample_flag.some(flag => flag) && sample.comment.trim().length == 0;
            return flagCondition || individualFlagCondition;

        });
        return refreshState;
    }

    refreshRegression(index: number, dataObj: GraphDataEntry, saveApiCalled?: boolean) {
        index = this.getwholeindex(index);
        this.onCommentComplete(index, dataObj, saveApiCalled);
    }

    onCommentComplete(index: number, dataObj: GraphDataEntry, saveApiCalled?: boolean) {
        const filterCommentText = this.commentText.filter((res) => res.target_name === dataObj.target_name && res.run_id === dataObj.run_id);
        const commentPayload = filterCommentText;
        if (!commentPayload) {
            this.recalculationStates[dataObj?.target_name + '_' + dataObj?.run_id] = false;
            this.panelStates[dataObj?.target_name + '_' + dataObj?.run_id] = false;
            return;
        }
        const regressiondata = {
            data: commentPayload,
            directCall: saveApiCalled,
            filePath: this.searchResult.file_path,
            processingType: 'regression'
        };

        this.recalculationStates[dataObj?.target_name + '_' + dataObj?.run_id] = true;
        this.panelStates[dataObj?.target_name + '_' + dataObj?.run_id] = true;
        this.http.post(this.regressionUrl, regressiondata).pipe(take(1)).subscribe({
            next: (res: any) => {
                try {
                    const updatedGraphData = res;
                    const targetName = res.target_name;
                    const runId = res.run_id;
                    this.recalculationStates[dataObj?.target_name + '_' + dataObj?.run_id] = false;
                    this.paginatedData.data = this.paginatedData.data.map((item, i) =>
                        i === index ? updatedGraphData : item
                    );
                    this.graphdata = this.graphdata?.map(target => {
                        if (target.target_name === targetName) {
                            const updatedGraphData = target.graph_data.map(data =>
                                data.run_id === runId ? res : data
                            );
                            return {
                                ...target,
                                graph_data: updatedGraphData
                            };
                        }
                        return target;
                    });
                    this.fetchRegressionData = false;
                    this.renderGraphsForCurrentPage();
                    this.cdr.detectChanges();
                }
                catch (error) {
                    this.regressionApiError = 'Could not refresh graph data, please contact administrator.';
                }
            },
            error: (err) => {
                console.error('API error:', err);
                this.recalculationStates[dataObj?.target_name + '_' + dataObj?.run_id] = false;
                this.panelStates[dataObj?.target_name + '_' + dataObj?.run_id] = false;
            }
        });
    }

    getwholeindex(index: number) {
        index = this.pageIndex * 10 + index;
        return index;
    }

    handlePanelOpened(dataObj: any, index: number): void {
        const panelKey = `${dataObj.target_name}_${dataObj.run_id}`;
        if (!this.calledPanels.has(panelKey) && dataObj.save === true && this.searchResult.iteration == 0) {
            this.calledPanels.add(panelKey);
            this.onCommentComplete(this.getwholeindex(index), dataObj, true);
        }
    }

    submitGraphDetails() {
        this.submitMessage = '';
        this.submitResultLoader = true;
        this.submitEnabled = false;
        this.executionId = Math.floor(new Date().getTime() / 1000.0).toString();
        this.searchResult.executionId = this.executionId;
        this.searchResult.commentText = this.commentText;
        localStorage.setItem('iteration1Called', 'true');
        this.http.post(this.AnalysisDataURL, this.searchResult).subscribe(
            res => {
                this.submitResultLoader = false;
                this.isFetching = true;
                this.selectedTargetName = null;
                this.fetchAnalysisData();
            },
            error => {
                this.submitResultLoader = false;
                this.submitStatus = false;
                this.submitMessage = 'Unexpected error occurred. Please try again later.'
//                 console.error('Error details:', error);
            }
        );

    }

    saveTargetDetails(selectedTargetName: string, index: number, dataObj: GraphDataEntry) {
        index = this.getwholeindex(index);
        this.errormessage = false;
        this.fetchRegressionData = true;
        const targetData = this.commentText.filter((item) => item.target_name === dataObj.target_name && item.run_id === dataObj.run_id);
        this.recalculationStates[dataObj?.target_name + '_' + dataObj?.run_id] = true;
        this.panelStates[dataObj?.target_name + '_' + dataObj?.run_id] = true;
        const saveTargetData = {
            commentText: {
                data: targetData[0],
                targetName: selectedTargetName
            },
            path: this.searchResult.file_path,
        };
        this.http.post(this.commentUrl, saveTargetData).subscribe({
            next: (res: any) => {
                this.callEvent = false;
                this.onCommentComplete(index, dataObj, true);
                this.GetEventData();
            },
            error: (error) => {
             
                this.recalculationStates[dataObj?.target_name + '_' + dataObj?.run_id] = false;
                this.errormessage = true;
            }
        });

    }

    checkPanelStatus() {
        if (this.searchResult.analysisType === 'qPCR') {
            this.graphdata?.forEach(item => {
                const allSaved = item.graph_data?.every((data: any) => data.save === true);
                this.savedTargetData[item.target_name] = allSaved;
            });
        }
        else {
            this.searchResult.CompileRuns?.forEach(item => {
                const allSaved = item.save === true;
                this.savedTargetData[item.target_name] = allSaved;
            })
        }
    }

    checkIfAllTargetsSaved() {
        this.showSubmitButton = this.graphdata?.every((res) => res.graph_data.every((data) => data.save === true));
    }

    isValidNumber(value: any): boolean {
        return value !== null && value !== undefined && !isNaN(value) && value !== 'Undetermined';
    }

    setStep(index: number) {
        this.step = index;

    }
    ngOnDestroy() {
        // Unsubscribe from the observable to avoid memory leaks
        if (this.singleSearchData) {
            this.singleSearchData.unsubscribe();
        }
        if (this.currentLoginUser) {
            this.currentLoginUser.unsubscribe();
        }
        if (this.getEventData) {
            this.getEventData.unsubscribe();
        }
        if (this.PostEventData) {
            this.PostEventData.unsubscribe();
        }
        this.analysisId = '';
    }
}

